import React, {Component} from 'react';
import config from 'react-global-configuration';
import {Input, Label} from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import axios from "axios";
import invLogo from "../assets/img/innoviti-logo.png";
import {Link} from "react-router-dom";


class AddUser extends Component {

    state = {
        email: '',
        phone: '',
        password: '',
        confirm_password: '',
        userType: '',
        is_active:'',
        contact_title:'',
        startDate:'',
        userGroup: '',
        userSubGroup: '',
        organization: '',
        organizationName: '',
        designation:'',
        extra_data:null,
        selectedFile: null,
        newUserModel: false,
        editUserModel: false,
        loading: true,
        _notificationSystem: null,
        userGroups: [],
        login_type: 'Standard',
        epassword: '',
        ecpassword: '',
        userSubGroups: [],
        organizationList: [],
        object_type: '',
        object_code:'',
        updated_by:'',
        created_by:'',
        account_expiry_date: '',
        approve:[],
        action_type:'',
        edit_user_id:'',
        logged_user_type:'',
        edit_file:null,
        auth_type:'',
        send_mail: false
    };

    constructor() {
        super();
        this.state = {
            email: '',
            errors: '',
            OTP_SEND: false,
            OTP_VALUE: '',
            loading: false,
            mobile: '',
            _notificationSystem: null,
        };

        this.validator = new SimpleReactValidator();
        this.validator1 = new SimpleReactValidator();
    }


    onChangeEmail(e) {
        this.setState({[e.target.name]: e.target.value});
    }

    onChangeMobile(e) {

        if (isNaN(e.target.value)) {

        } else {
            this.setState({
                mobile: e.target.value
            });
        }


    }

    onChangeOTP(e) {
        if (isNaN(e.target.value)) {
        } else {
            this.setState({
                OTP_VALUE: e.target.value
            });
        }
    }

    onSubmitData(e) {
        e.preventDefault();
        if (this.state.email === "") {
            this.props.handleClick("tr", 3, "Enter Email Address.");
            return false;
        }

        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(this.state.email) === false) {
            this.props.handleClick("tr", 3, "Enter Valid Email Id.");
            return false;
        }

        if (this.state.mobile.length === "") {
            this.props.handleClick("tr", 3, "Enter Mobile Number.");
            return false;
        }

        if (this.state.mobile.length !== 10) {
            this.props.handleClick("tr", 3, "Enter Valid Mobile Number.");
            return false;
        }


        axios.post(config.get('API_URL') + '/users/addUser', {
            email: this.state.email,
            mobile: this.state.mobile,
            password: this.state.mobile,
            firstName: '',
            lastName: '',
            phone: this.state.mobile,
            loginType: 'Standard',
            userGroup: 2,
            userSubGroup: 107,
            extra_data: '{}',
            is_active: 'active',
            contact_title: 'Mr',
            user_type: 2
        })
            .then(response => {

                if (response.data.status == 'Registered!') {
                    this.props.handleClick("tr", 1, "Record has been saved.");

                    window.location.href = '/';
                } else {
                    this.props.handleClick("tr", 3, response.data.error);
                }
            });
    }


    render() {

        return (
            <div>
                <div className="">
                    <div className="col-md-12">
                        <div className="col-md-2"></div>
                        <div className="col-md-8 header">Enter details for add new user
                            <hr/>
                        </div>

                        <div className="col-md-2"></div>
                    </div>
                    <div className="col-md-12">
                        <div className="col-md-2"></div>
                        <div className="col-md-8 col-md-8">
                            <form className="" method="POST" onSubmit={this.onSubmitData.bind(this)}>
                                <div className="clearfix"></div>
                                <div className="form-group">
                                    <div className="col-md-12 marginTop">
                                        <div className="col-md-4 rightText">
                                            <label>Email Id:</label>
                                        </div>
                                        <div className="col-md-8">
                                            <Input placeholder="your@email.com" name="email" type="email"
                                                   className="form-control" value={this.state.email}
                                                   onChange={this.onChangeEmail.bind(this)}/>
                                            {this.validator.message('email', this.state.email, 'required|email')}
                                        </div>
                                    </div>


                                </div>

                                <div className="form-group">
                                    <div className="col-md-12 marginTop">
                                        <div className="col-md-4 rightText">
                                            <label>Mobile Number:</label>
                                        </div>
                                        <div className="col-md-8">
                                            <Input placeholder="Mobile Number" name="mobile" type="mobile"
                                                   className="form-control"
                                                   value={this.state.mobile} onChange={this.onChangeMobile.bind(this)}
                                                   maxlength="10"/>
                                            {this.validator.message('mobile', this.state.mobile, 'required|mobile')}
                                        </div>
                                    </div>
                                </div>

                                <p className="errmsg">{this.state.errors}</p>
                                <div className="col-md-12 marginTop">
                                    <div className="col-md-4">
                                    </div>
                                    <div className="col-md-8">
                                        <button
                                            type="submit" className="addSubmit">Save
                                        </button>

                                    </div>

                                </div>

                                <br/>
                            </form>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

export default AddUser;